import styled from 'styled-components';
import { palette } from 'styled-tools';

import { minWidth } from '@calm-web/design-system';

import { PageWrap } from '../../styles';
import ValuePropsList from '../../ValuePropsList';

export const AccountPageWrap = styled(PageWrap)<{
	backgroundColor?: string;
}>`
	background: ${({ backgroundColor }) => palette(backgroundColor ?? 'gradientCalmBrandDark')};
`;

export const AccountValuePropsList = styled(ValuePropsList)`
	margin-top: 0;
	padding-top: 0;
	padding-bottom: 40px;

	${minWidth('desktop')} {
		padding-bottom: 0;
	}
`;

export const AuthFormWrapper = styled.div`
	display: flex;
	flex-direction: column;
	max-width: 700px;
	h1 {
		margin-bottom: 8px;
	}
`;

export const ImageWrapper = styled.div`
	height: 230px;
	width: 100%;
	position: relative;
`;
